import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SigningService } from '@app/certificates/signing/signing.service';
import { takeUntil, first } from 'rxjs/operators';
import { ISigningTextsInterface, ISigningValuesInterface, SigningTexts } from '@app/certificates/signing/signing';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { cadesValues } from '@app/certificates/signing/signing.values';
import { pdfValues } from '@app/certificates/signing/signing.values';
import { xmlValues } from '@app/certificates/signing/signing.values';


@Component({
  selector: 'cloud-business-file-settings',
  templateUrl: './business-file-settings.component.html',
  styleUrls: ['./business-file-settings.component.scss']
})
export class BusinessFileSettingsComponent {

  @Output() close: EventEmitter<any> = new EventEmitter();
  title = '';
  unsubscribe$: Subject<void> = new Subject<void>();
  fileForm: FormGroup;
  signTypeForm: FormGroup;
  texts: ISigningTextsInterface = new SigningTexts();
  values: ISigningValuesInterface;
  padesTypes = pdfValues.signType;
  cadesTypes = cadesValues.signType;
  xadesTypes = xmlValues.signType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService,
    private signingService: SigningService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.title = this.translateService.instant('businessTexts.fileSettings');

    this.signingService.values(this.data.file.name.split('.').pop())
      .pipe(
        first(),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(v => this.initTypeForm(v));
  }

  private initTypeForm(values: ISigningValuesInterface) {
    this.values = values;

    this.signTypeForm = this.formBuilder.group({
      signFormat: [this.data.settings ? this.data.settings.signFormat : values.defaults.signFormat, Validators.required],
      signLevel: [this.data.settings ? this.data.settings.signLevel : values.defaults.signLevel, Validators.required],
      signType: [this.data.settings ? this.data.settings.signType : values.defaults.signType, Validators.required],
      signHashAlg: [this.data.settings ? this.data.settings.signHashAlg : values.defaults.signHashAlg, Validators.required],
    });
    this.setTypes();
  }

  setTypes() {
    if (this.signTypeForm.value.signFormat === 'PAdES') {
      this.values.signType = this.padesTypes;
    }
    if (this.signTypeForm.value.signFormat === 'XAdES') {
      this.values.signType = this.xadesTypes;
    }
    if (this.signTypeForm.value.signFormat === 'CAdES') {
      this.values.signType = this.cadesTypes;
    }
  }

  setInitialTypes(event) {
    this.setTypes();
    this.signTypeForm.controls['signType'].setValue(this.values.signType[0].value);
  }

  closeDialog() {
    this.close.emit(null);
  }
  onSave() {
    this.close.emit(this.signTypeForm.dirty ? this.signTypeForm.value : null);
  }
}
